import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import {message, Button, Table, Select, Input} from 'antd';
import {hasAuth, createUuid} from "../../../utils/NHCore";
import NHFetch from "../../../utils/NHFetch";

/**
 * 人脸识别信息查询 
 */
class Rlsbxxcx extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
            isShowXyw: false, // 是否显示【是否开通校园网】字段
            success: false, // 接口加载成功的回调状态
        }
    }

    // 自选手机号是否关联校园网
    // （关联时：显示是否开通校园网字段，无论是否自选手机号都会显示在内）
    // （不关联时：只显示自选了手机号码的学生，且不显示开通校园网字段）
    componentWillMount() {
        NHFetch('api/zhxg-xtgl/openapi/getCsszByCsbz', "GET", {csbz: 'YXXT_ZXSJH_SFXYGLXYW'})
            .then(res => {
                if (res) {
                    if (res.data && res.code === 200) {
                        if (res.data.csz === 'true') {
                            this.setState({isShowXyw: true});
                        }
                    }
                }
            }).then(() => this.setState({success: true}));
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel(' 人脸识别信息');
    }

    render() { 
        const columns = [
            {
                title: '序号',
                key: 'ROW_ID',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                key: 'XH',
                dataIndex: 'XH',
                width: '80px',
                searchType: "input"
            } , {
                title: '姓名',
                key: 'XM',
                dataIndex: 'XM',
                width: '80px',
                searchType: "input"
            }, {
                title: '性别',
                key: 'XB',
                dataIndex: 'XB',
                width: '60px',
                search: 'select',
                searchType: "select"
            }, {
                title: '身份证号',
                key: 'SFZH',
                dataIndex: 'SFZH',
                width: '100px',
                searchType: "input"
            }, {
                title: '出生日期',
                key: 'CSRQ',
                width: '60px',
                dataIndex: 'CSRQ',
                searchType: "input"
            }, {
                title: '身份证地址',
                key: 'DZ',
                width: '150px',
                dataIndex: 'DZ',
                searchType: "input"
            }, {
                title: '身份证签发机关',
                key: 'QFJG',
                width: '120px',
                dataIndex: 'QFJG',
                searchType: "input"
            }, {
                title: '身份证有效期限',
                key: 'YXQX',
                width: '110px',
                dataIndex: 'YXQX',
                searchType: "input"
            }, {
                title: '刷卡时间',
                key: 'SKSJ',
                width: '100px',
                dataIndex: 'SKSJ',
                searchType: "input"
            }, {
                title: '身份证照片对比值（与现场人脸）',
                key: 'SFZZPBDZ',
                width: '100px',
                dataIndex: 'SFZZPBDZ',
                searchType: "input"
            }, {
                title: '录取照片比对值（与现场人脸）',
                key: 'LQZPPBDZ',
                width: '90px',
                dataIndex: 'LQZPPBDZ',
                searchType: "input"
            }, {
                title: '年度',
                key: 'ND',
                width: '60px',
                dataIndex: 'ND',
                searchType: "select"
            }] 

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div style={{width: '100%', height: '100%',}}> 
                        <NHTable
                            ref='nhTable'
                            rowKey={record => record.PKID}
                            sign={"zhxg_yxxt_rlsb_xxcx"}
                            columns={columns}
                            rangeFilter={true}
                        > 
                        {
                            hasAuth("zhxg_yxgl_tjcx_rlsb_xxcx:export") && 
                            <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{marginLeft: 10}}>导出</Button>
                            
                        }
                        </NHTable>  
                </div>
            </div>
        )
    }
}

export default Rlsbxxcx;



// WEBPACK FOOTER //
// ./components/tjcx/rlsbxxcx/index.js